import { useQuery } from '@tanstack/react-query'
import api from '@/services/api'
import type { TrajectoryInfo } from '@/types/forklift'

export interface ScenarioTrajectoryResponse {
  fork_id: string
  log_id: string
  scenario_id: string | null
  scenario_name: string | null
  trajectories: TrajectoryInfo[]
}

// シナリオ実行開始ログのルートプレビューを log_id 単位で取得する。
// trajectories は 30 分ロールアップでバケットの context から落とされるため、
// 退避テーブルを参照する /scenario-trajectory から遅延取得する。
export function useScenarioTrajectory(
  forkId: string | undefined,
  logId: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['scenario-trajectory', forkId, logId],
    queryFn: async () => {
      const { data } = await api.get<ScenarioTrajectoryResponse>(
        '/scenario-trajectory',
        { params: { fork_id: forkId, log_id: logId } }
      )
      return data
    },
    enabled: enabled && !!forkId && !!logId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
